import React from 'react';
import Theme from './../../../StyledComponentThemes';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export const Svg = styled.svg`
    margin: ${p => (p.margin ? p.margin : '0')};
    transform: ${p => (p.cssTransform ? p.cssTransform : '')};
`;

export default class IconBase extends React.PureComponent {
    static propTypes = {
        margin: PropTypes.string,
        color: PropTypes.string,
        flipped: PropTypes.bool,
        width: PropTypes.string,
        height: PropTypes.string,
        direction: PropTypes.string,
        cssTransform: PropTypes.string,
    };

    render() {
        return <span>Replace with the svg of the icon</span>;
    }
}

// Warning Icon
export class IconWarning extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '16px'}
                height={this.props.height || '15px'}
                viewBox="0 0 16 15"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-329.000000, -339.000000)"
                        fill={this.props.color || Theme.yellow}
                    >
                        <g transform="translate(313.000000, 155.000000)">
                            <g transform="translate(16.000000, 182.000000)">
                                <g transform="translate(0.000000, 2.500000)">
                                    <path d="M15.6060419,11.1698015 L9.68762228,1.16802773 C8.76659444,-0.388581451 7.25774262,-0.389450944 6.33471689,1.16607138 L0.395652361,11.1721926 C-0.527373368,12.7272802 0.2205039,14 2.05767584,14 L13.9406886,14 C15.7776386,14 16.5268478,12.7261933 15.6060419,11.1698015 L15.6060419,11.1698015 Z M8.06533464,12.2384079 C7.49637963,12.2384079 7.04352429,11.7954014 7.04352429,11.2380567 C7.04352429,10.6807119 7.49615764,10.237488 8.06533464,10.237488 C8.63406766,10.237488 9.08714499,10.6807119 9.08714499,11.2380567 C9.08714499,11.7954014 8.63428965,12.2384079 8.06533464,12.2384079 L8.06533464,12.2384079 Z M8.7894592,9.60428 L7.34121008,9.60428 L6.85372463,3.8301968 L9.27738862,3.8301968 L8.7894592,9.60428 L8.7894592,9.60428 Z"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

// Error Icon
export class IconError extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '16px'}
                height={this.props.height || '16px'}
                viewBox="0 0 16 16"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-328.000000, -287.000000)"
                        fill={this.props.color}
                    >
                        <g transform="translate(313.000000, 155.000000)">
                            <g transform="translate(15.000000, 130.000000)">
                                <g transform="translate(0.000000, 2.000000)">
                                    <path d="M8,0 C3.58155556,0 0,3.58133333 0,8 C0,12.4182222 3.58155556,16 8,16 C12.418,16 16,12.4182222 16,8 C16,3.58133333 12.418,0 8,0 M8.07997886,12.943843 C7.47863499,12.943843 7,12.4691931 7,11.872038 C7,11.2748829 7.47840037,10.8000002 8.07997886,10.8000002 C8.6810881,10.8000002 9.15995771,11.2748829 9.15995771,11.872038 C9.15995771,12.4691931 8.68132272,12.943843 8.07997886,12.943843 L8.07997886,12.943843 Z M8.84593016,9.98651766 L7.31523668,9.98651766 L6.80000019,3.79999995 L9.3616359,3.79999995 L8.84593016,9.98651766 L8.84593016,9.98651766 Z"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

// List icon
export class IconList extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                margin={this.props.margin}
                width={this.props.width || '20px'}
                height={this.props.height || '14px'}
                viewBox="0 0 20 14"
            >
                <title>List</title>
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-498.000000, -13.000000)"
                        fill={this.props.color || '#FFFFFF'}
                    >
                        <g transform="translate(490.000000, 8.000000)">
                            <path
                                d="M12,11 L28,11 L28,9 L12,9 L12,11 Z M12,7 L28,7 L28,5 L12,5 L12,7 Z M12,15 L28,15 L28,13 L12,13 L12,15 Z M12,19 L28,19 L28,17 L12,17 L12,19 Z M8,15 L10,15 L10,13 L8,13 L8,15 Z M8,11 L10,11 L10,9 L8,9 L8,11 Z M8,7 L10,7 L10,5 L8,5 L8,7 Z M8,19 L10,19 L10,17 L8,17 L8,19 Z"
                                transform="translate(18.000000, 12.000000) scale(-1, 1) translate(-18.000000, -12.000000) "
                            ></path>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

// Lock icon
export class IconLock extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '13px'}
                height={this.props.height || '16px'}
                viewBox="0 0 13 16"
            >
                <title>Lock</title>
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g fill={this.props.color || Theme.defaultGray}>
                        <g>
                            <path d="M10.8295094,7.0577715 L10.8295094,4.35863043 C10.8295094,1.95175903 8.63160372,0 6.17955054,0 L6.09483469,0 L6.01482527,0 C3.56277209,0 1.41193082,1.95175903 1.41193082,4.35863043 L1.41193082,7.0577715 L0,7.0577715 L0,16 L12.2367337,16 L12.2367337,7.0577715 L10.8295094,7.0577715 L10.8295094,7.0577715 Z M7.5067655,14.1113072 L4.72996823,14.1113072 L5.41240146,11.4319332 C4.99331366,11.190993 4.73353276,10.7457823 4.72996823,10.2623838 C4.74956888,9.50967044 5.36539834,8.90966842 6.11836687,8.90966842 C6.87133539,8.90966842 7.48716485,9.50967044 7.5067655,10.2623838 C7.50594883,10.7472677 7.24556225,11.1945939 6.82433227,11.434757 L7.5067655,14.1113072 Z M8.45746558,7.0577715 L3.75102953,7.0577715 L3.75102953,4.35910107 C3.78511295,3.13715304 4.79247453,2.16811728 6.01482527,2.18143311 L6.1230733,2.18143311 L6.17955054,2.18143311 C7.40466946,2.16718631 8.41659745,3.1345811 8.45746558,4.35910107 L8.45746558,7.0577715 L8.45746558,7.0577715 Z"></path>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

// Checked Icon
export class IconChecked extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '18px'}
                height={this.props.height || '19px'}
                viewBox="0 0 19 19"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-867.000000, -1335.000000)"
                        fill={this.props.color}
                    >
                        <g transform="translate(515.000000, 146.000000)">
                            <g transform="translate(33.000000, 191.000000)">
                                <g transform="translate(1.000000, 987.000000)">
                                    <g transform="translate(318.000000, 11.000000)">
                                        <path d="M9.5,19 C4.25329488,19 0,14.7467051 0,9.5 C0,4.25329488 4.25329488,0 9.5,0 C14.7467051,0 19,4.25329488 19,9.5 C19,14.7467051 14.7467051,19 9.5,19 Z M3.51680083,9.83345227 L6.34522795,12.6618794 L7.75944151,11.2476658 L4.93101439,8.41923871 L3.51680083,9.83345227 Z M6.34522795,12.6618794 L7.75944151,14.076093 L15.5376161,6.29791836 L14.1234025,4.8837048 L6.34522795,12.6618794 Z"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

// UnChecked Icon
export class IconUnChecked extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '18px'}
                height={this.props.height || '19px'}
                viewBox="0 0 21 21"
            >
                <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                    opacity="1"
                >
                    <g
                        transform="translate(-866.000000, -1376.000000)"
                        stroke={this.props.color || '#ccc'}
                    >
                        <g transform="translate(515.000000, 146.000000)">
                            <g transform="translate(33.000000, 191.000000)">
                                <g transform="translate(1.000000, 987.000000)">
                                    <circle
                                        cx="327.5"
                                        cy="62.5"
                                        r="9.5"
                                    ></circle>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

// icon for expanding and contracting a column
export class IconDoubleArrow extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                margin={this.props.margin}
                width={this.props.width || '9px'}
                height={this.props.height || '7px'}
                viewBox="0 0 9 7"
            >
                <title>collapse-arrows</title>
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-163.000000, -8.000000)"
                        stroke={this.props.color ? this.props.color : '#C5CDD5'}
                    >
                        <g transform="translate(163.000000, 8.000000)">
                            <path d="M3.69999695,0 L0.790021192,3.55890261 L3.80000305,7"></path>
                            <path d="M7.69999695,0 L4.79002119,3.55890261 L7.80000305,7"></path>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

// Checkmark
export class IconCheckMark extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '11px'}
                height={this.props.height || '10px'}
                viewBox="0 0 11 10"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-35.000000, -198.000000)"
                        fill={this.props.color || Theme.blue}
                    >
                        <polygon points="44.7307692 198 46 199.364164 38.5961538 207.307692 35 203.44256 36.2692308 202.078396 38.5961538 204.579364"></polygon>
                    </g>
                </g>
            </Svg>
        );
    }
}

// Angle icon
export class IconAngle extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '6px'}
                height={this.props.height || '10px'}
                viewBox="0 0 7 12"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-103.000000, -138.000000)"
                        fillRule="nonzero"
                        fill={this.props.color || Theme.defaultGray}
                    >
                        <path d="M110,143.952096 C110,144.077844 109.958084,144.161677 109.874251,144.245509 L104.299401,149.820359 C104.215569,149.904192 104.08982,149.946108 104.005988,149.946108 C103.922156,149.946108 103.796407,149.904192 103.712575,149.820359 L103.125749,149.233533 C103.041916,149.149701 103,149.065868 103,148.94012 C103,148.856287 103.041916,148.730539 103.125749,148.688623 L107.820359,143.952096 L103.125749,139.257485 C103.041916,139.173653 103,139.08982 103,138.964072 C103,138.88024 103.041916,138.796407 103.125749,138.712575 L103.712575,138.125749 C103.796407,138.041916 103.922156,138 104.005988,138 C104.08982,138 104.215569,138.041916 104.299401,138.125749 L109.874251,143.700599 C109.958084,143.784431 110,143.868263 110,143.952096 Z"></path>
                    </g>
                </g>
            </Svg>
        );
    }
}

export class IconChevron extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '7px'}
                height={this.props.height || '11px'}
                viewBox="0 0 280 445"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-2878.000000, -1562.000000)"
                        fill={this.props.color || Theme.blue}
                        fillRule="nonzero"
                    >
                        <g transform="translate(2878.000000, 1562.000000)">
                            <path d="M280,223 C280,233 277,241 270,249 L84,435 C77,442 68,445 58,445 C48,445 39,442 32,435 L10,413 C3,406 0,397 0,387 C0,377 3,369 10,362 L149,223 L10,84 C3,77 0,68 0,58 C0,48 3,39 10,32 L32,11 C39,4 48,0 58,0 C68,0 77,4 84,11 L270,197 C277,204 280,213 280,223 Z"></path>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

export class IconTriangle extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '7px'}
                height={this.props.height || '11px'}
                viewBox="0 0 450 450"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-2878.000000, -1562.000000)"
                        fill={this.props.color || Theme.blue}
                        fillRule="nonzero"
                    >
                        <g transform="translate(2878.000000, 1562.000000)">
                            <path d="M399.494,209.312L146.627,10.473c-5.532-3.88-15.41-8.072-22.118-8.917C102.771-1.18,59.332-3.352,59.332,23v435.708 c0,26.353,43.415,24.192,65.147,21.463c6.707-0.845,16.573-5.036,22.111-8.917l252.903-198.856 C430.021,254.979,430.021,226.735,399.494,209.312z"></path>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

export class IconX extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '10px'}
                height={this.props.height || '10px'}
                viewBox="0 0 342 342"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-828.000000, -90.000000)"
                        fill={this.props.color || '#fff'}
                        fillRule="nonzero"
                    >
                        <g transform="translate(828.000000, 90.000000)">
                            <path d="M328.75,267.75 L231.75,170.75 L328.75,73.75 C345.75,56.75 345.75,29.75 328.75,12.75 C311.75,-4.25 284.75,-4.25 267.75,12.75 L170.75,109.75 L73.75,12.75 C56.75,-4.25 29.75,-4.25 12.75,12.75 C-4.25,29.75 -4.25,56.75 12.75,73.75 L109.75,170.75 L12.75,267.75 C-4.25,284.75 -4.25,311.75 12.75,328.75 C20.75,336.75 31.75,341.75 42.75,341.75 C53.75,341.75 65.75,336.75 73.75,328.75 L170.75,231.75 L267.75,328.75 C276.75,336.75 287.75,341.75 298.75,341.75 C309.75,341.75 320.75,336.75 328.75,328.75 C345.75,311.75 345.75,284.75 328.75,267.75 Z"></path>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

export class IconXCircle extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '14px'}
                height={this.props.height || '14px'}
                viewBox="0 0 438 438"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-861.000000, -324.000000)"
                        fill={this.props.color || '#fff'}
                        fillRule="nonzero"
                    >
                        <g transform="translate(861.000000, 324.000000)">
                            <path d="M328,284 C328,279 326,274 322,271 L271,219 L322,167 C326,164 328,159 328,154 C328,149 326,145 322,141 L297,116 C293,112 289,110 284,110 C279,110 274,112 271,116 L219,167 L167,116 C164,112 159,110 154,110 C149,110 145,112 141,116 L116,141 C112,145 110,149 110,154 C110,159 112,164 116,167 L167,219 L116,271 C112,274 110,279 110,284 C110,289 112,293 116,297 L141,322 C145,326 149,328 154,328 C159,328 164,326 167,322 L219,271 L271,322 C274,326 279,328 284,328 C289,328 293,326 297,322 L322,297 C326,293 328,289 328,284 Z M438,219 C438,259 429,296 409,329 C389,363 363,389 329,409 C296,429 259,438 219,438 C179,438 142,429 109,409 C75,389 49,363 29,329 C9,296 0,259 0,219 C0,179 9,142 29,109 C49,75 75,49 109,29 C142,9 179,0 219,0 C259,0 296,9 329,29 C363,49 389,75 409,109 C429,142 438,179 438,219 Z"></path>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

export class IconCheckMarkCircle extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '14px'}
                height={this.props.height || '14px'}
                viewBox="0 0 438 438"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-3283.000000, -103.000000)"
                        fill={this.props.color || '#fff'}
                        fillRule="nonzero"
                    >
                        <g transform="translate(3283.000000, 103.000000)">
                            <path d="M366,173 C366,167 365,163 361,160 L335,134 C332,130 327,128 322,128 C317,128 313,130 310,134 L193,250 L128,186 C125,182 121,180 116,180 C111,180 106,182 103,186 L77,211 C73,215 72,219 72,224 C72,230 73,234 77,237 L180,341 C184,344 188,346 193,346 C198,346 203,344 206,341 L361,186 C365,182 366,178 366,173 Z M438,219 C438,259 429,296 409,329 C389,363 363,389 329,409 C296,429 259,438 219,438 C179,438 142,429 109,409 C75,389 49,363 29,329 C9,296 0,259 0,219 C0,179 9,142 29,109 C49,75 75,49 109,29 C142,9 179,0 219,0 C259,0 296,9 329,29 C363,49 389,75 409,109 C429,142 438,179 438,219 Z"></path>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

// shared icon
export class IconShared extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '20px'}
                height={this.props.height || '10px'}
                viewBox="0 0 73 36"
            >
                <title>Shared</title>
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-1519.000000, -2126.000000)"
                        fill={this.props.color || Theme.defaultGray}
                    >
                        <g transform="translate(72.000000, 235.000000)">
                            <path d="M1519.092,1923.521 L1519.091,1923.521 L1519.091,1926.498 L1506.05,1926.499 L1506.05,1926.496 L1506.05,1922.409 L1506.05,1922.394 L1506.05,1922.379 C1506.041,1921.479 1505.644,1918.643 1501.395,1916.081 C1500.66,1915.056 1500.054,1913.674 1499.424,1912.073 C1498.98,1910.944 1499.055,1909.979 1499.055,1908.609 C1499.055,1907.6 1498.863,1905.982 1499.113,1905.093 C1499.958,1902.075 1502.098,1901.24 1504.604,1901.24 C1507.109,1901.24 1509.246,1902.071 1510.093,1905.083 C1510.343,1905.974 1510.153,1907.596 1510.153,1908.608 C1510.153,1909.975 1510.229,1910.936 1509.787,1912.063 C1509.024,1914.008 1508.279,1915.651 1507.3,1916.701 C1511.136,1917.387 1513.727,1919.386 1515.472,1920.163 C1519.074,1921.762 1519.092,1923.521 1519.092,1923.521 Z M1460.133,1922.39 L1460.133,1922.409 L1460.133,1926.498 L1447.124,1926.5 L1447.124,1923.523 C1447.124,1923.523 1447.14,1921.77 1450.73,1920.17 C1452.465,1919.396 1455.036,1917.412 1458.841,1916.712 C1457.862,1915.667 1457.132,1914.027 1456.362,1912.073 C1455.919,1910.943 1455.993,1909.978 1455.993,1908.608 C1455.993,1907.599 1455.802,1905.981 1456.051,1905.092 C1456.896,1902.074 1459.035,1901.24 1461.542,1901.24 C1464.047,1901.24 1466.184,1902.071 1467.03,1905.082 C1467.282,1905.973 1467.092,1907.595 1467.092,1908.607 C1467.092,1909.974 1467.167,1910.935 1466.725,1912.062 C1466.086,1913.691 1465.459,1915.102 1464.697,1916.136 C1460.536,1918.683 1460.143,1921.482 1460.133,1922.374 L1460.133,1922.39 Z M1497.981,1917.788 C1502.934,1919.989 1502.957,1922.405 1502.957,1922.405 L1502.957,1926.492 L1463.227,1926.497 L1463.227,1922.405 C1463.227,1922.405 1463.251,1919.997 1468.185,1917.797 C1470.568,1916.734 1474.103,1914.007 1479.332,1913.046 C1477.988,1911.608 1476.984,1909.356 1475.926,1906.668 C1475.315,1905.116 1475.418,1903.792 1475.418,1901.906 C1475.418,1900.521 1475.155,1898.297 1475.498,1897.075 C1476.658,1892.928 1479.6,1891.78 1483.045,1891.78 C1486.488,1891.78 1489.426,1892.922 1490.588,1897.063 C1490.934,1898.288 1490.672,1900.517 1490.672,1901.906 C1490.672,1903.787 1490.776,1905.107 1490.168,1906.657 C1489.118,1909.331 1488.098,1911.587 1486.75,1913.03 C1492.021,1913.975 1495.582,1916.722 1497.981,1917.788 Z"></path>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

// Search icon
export class IconSearch extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '12px'}
                height={this.props.height || '12px'}
                viewBox="0 0 12 12"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-148.000000, -241.000000)"
                        fillRule="nonzero"
                        fill={this.props.color || Theme.defaultGray}
                    >
                        <g transform="translate(148.000000, 241.000000)">
                            <path d="M11.6661786,11.6661786 C11.2210835,12.1112738 10.5183016,12.1112738 10.0732064,11.6661786 L8.08199122,9.6749634 C7.26207906,10.1903367 6.30161054,10.5183016 5.24743777,10.5183016 C2.34260615,10.5183016 0,8.1522694 0,5.24743777 C0,2.34260615 2.34260615,0 5.24743777,0 C8.1522694,0 10.5183016,2.34260615 10.5183016,5.24743777 C10.5183016,6.30161054 10.1903367,7.26207906 9.6749634,8.08199122 L11.6661786,10.0732064 C12.1112738,10.5183016 12.1112738,11.2210835 11.6661786,11.6661786 Z M5.24743777,1.49926794 C3.18594436,1.49926794 1.49926794,3.18594436 1.49926794,5.24743777 C1.49926794,7.33235725 3.18594436,9.01903367 5.24743777,9.01903367 C7.33235725,9.01903367 9.01903367,7.33235725 9.01903367,5.24743777 C9.01903367,3.18594436 7.33235725,1.49926794 5.24743777,1.49926794 Z"></path>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

export class IconCollapseCaret extends IconBase {
    render() {
        return (
            <Svg
                margin={this.props.margin}
                width={this.props.width || '10px'}
                height={this.props.height || '16px'}
                cssTransform={this.props.cssTransform}
                viewBox="0 0 10 6"
                version="1.1"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-325.000000, -1191.000000)"
                        fill={this.props.color || Theme.darkText}
                    >
                        <g transform="translate(313.000000, 155.000000)">
                            <g id="Group-15">
                                <g
                                    id="Group"
                                    transform="translate(0.000000, 795.000000)"
                                >
                                    <polygon
                                        id="Rectangle-13"
                                        transform="translate(17.000000, 244.000000) rotate(90.000000) translate(-17.000000, -244.000000)"
                                        points="14 239 20 244 14 249"
                                    ></polygon>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

export class IconCaretDown extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '9px'}
                height={this.props.height || '4px'}
                viewBox="0 0 292 164"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-1710.000000, -2063.000000)"
                        fill={this.props.color || Theme.darkText}
                        fillRule="nonzero"
                    >
                        <g transform="translate(1710.000000, 2063.000000)">
                            <path d="M292,18 C292,23 290,27 287,31 L159,159 C155,162 151,164 146,164 C141,164 137,162 133,159 L5,31 C2,27 0,23 0,18 C0,13 2,9 5,5 C9,1 13,0 18,0 L274,0 C279,0 283,1 287,5 C290,9 292,13 292,18 Z"></path>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

// Email (Envelope) Icon
export class IconEmail extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '21px'}
                height={this.props.height || '16px'}
                viewBox="0 0 21 16"
            >
                <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                    transform="translate(-123.000000, -343.000000)"
                >
                    <g
                        transform="translate(0.000000, 242.000000)"
                        fill={this.props.color || Theme.darkText}
                    >
                        <g transform="translate(0.000000, 35.000000)">
                            <g transform="translate(15.000000, 57.000000)">
                                <g transform="translate(82.000000, 0.000000)">
                                    <path d="M46.9995553,9 L36.4981342,16.7764402 L25.9967131,9 L46.9995553,9 Z M25.9991658,24.0039839 L25.9991658,10.997931 L36.5005302,18.7362409 L46.9991309,10.997931 L46.9991309,24.0039839 L25.9991658,24.0039839 Z"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

// Directions Icon
export class IconDirections extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '18px'}
                height={this.props.height || '20px'}
                viewBox="0 0 18 20"
            >
                <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                    transform="translate(-208.000000, -340.000000)"
                >
                    <g
                        transform="translate(0.000000, 242.000000)"
                        fill={this.props.color || Theme.darkText}
                        fillRule="nonzero"
                    >
                        <g transform="translate(0.000000, 35.000000)">
                            <g transform="translate(15.000000, 57.000000)">
                                <g transform="translate(164.000000, 0.000000)">
                                    <g transform="translate(29.000000, 6.000000)">
                                        <path d="M0.10485778,5.9690722 L3.68604204,0.323440535 C3.7703052,0.197045797 3.85456836,0.112782638 4.00202889,0.0495852684 C4.31801574,-0.0768094702 4.65506837,0.0495852684 4.82359469,0.302374746 L8.40477895,5.9690722 C8.7207658,6.47465115 8.27838421,7.10662484 7.6885421,6.95916431 L5.35762686,6.49571694 L5.35762686,12.4864618 C7.00075846,10.9065276 8.60552897,10.2400278 11.0491606,10.1978962 L10.5857132,7.57007222 C10.4593185,7.00129589 11.0912922,6.53784852 11.5758053,6.85383537 L17.221437,10.4350196 C17.3478317,10.5192828 17.4320949,10.6035459 17.4952923,10.7510065 C17.621687,11.0669933 17.4952923,11.404046 17.2425028,11.5725723 L11.5758053,15.1537565 C11.0702264,15.4697434 10.4382527,15.0273618 10.5857132,14.4375197 L11.0491606,11.8616293 C7.55223948,11.9458924 5.35762686,13.2868544 5.35762686,16.8048413 L5.35762686,19.5480679 C5.35762686,19.8008573 5.16803475,19.9904494 4.91524527,19.9904494 L3.83173109,19.9988882 C3.57894161,19.9988882 3.3893495,19.8092961 3.3893495,19.5565066 L3.3893495,6.49571694 L0.842160423,6.95916431 C0.231252519,7.10662484 -0.211129066,6.47465115 0.10485778,5.9690722 Z"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

// Info Icon
export class IconInfo extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '20px'}
                height={this.props.height || '20px'}
                viewBox="0 0 20 20"
            >
                <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                    transform="translate(-288.000000, -340.000000)"
                >
                    <g
                        transform="translate(0.000000, 242.000000)"
                        fill={this.props.color || Theme.darkText}
                        fillRule="nonzero"
                    >
                        <g transform="translate(0.000000, 35.000000)">
                            <g transform="translate(15.000000, 57.000000)">
                                <g transform="translate(246.000000, 0.000000)">
                                    <g transform="translate(27.000000, 6.000000)">
                                        <path d="M10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 Z M9.77272727,6.81818182 C10.4004545,6.81818182 10.9090909,6.30954545 10.9090909,5.68181818 C10.9090909,5.05409091 10.4004545,4.54545455 9.77272727,4.54545455 C9.145,4.54545455 8.63636364,5.05409091 8.63636364,5.68181818 C8.63636364,6.30954545 9.145,6.81818182 9.77272727,6.81818182 Z M8.18181818,15.9090909 L11.8181818,15.9090909 L11.8181818,15.4545455 L10.9090909,15.4545455 L10.9090909,8.63636364 L10.9090909,8.18181818 L9.09090909,8.18181818 L8.18181818,8.18181818 L8.18181818,8.63636364 L9.09090909,8.63636364 L9.09090909,15.4545455 L8.18181818,15.4545455 L8.18181818,15.9090909 Z"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

// Info Icon
export class IconItalicInfo extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '12px'}
                height={this.props.height || '12px'}
                viewBox="0 0 111.577 111.577"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(0.000000, 0.000000)"
                        fill={this.props.color || Theme.darkText}
                        fillRule="nonzero"
                    >
                        <path d="M78.962,99.536l-1.559,6.373c-4.677,1.846-8.413,3.251-11.195,4.217c-2.785,0.969-6.021,1.451-9.708,1.451 c-5.662,0-10.066-1.387-13.207-4.142c-3.141-2.766-4.712-6.271-4.712-10.523c0-1.646,0.114-3.339,0.351-5.064 c0.239-1.727,0.619-3.672,1.139-5.846l5.845-20.688c0.52-1.981,0.962-3.858,1.316-5.633c0.359-1.764,0.532-3.387,0.532-4.848 c0-2.642-0.547-4.49-1.636-5.529c-1.089-1.036-3.167-1.562-6.252-1.562c-1.511,0-3.064,0.242-4.647,0.71 c-1.59,0.47-2.949,0.924-4.09,1.346l1.563-6.378c3.829-1.559,7.489-2.894,10.99-4.002c3.501-1.111,6.809-1.667,9.938-1.667 c5.623,0,9.962,1.359,13.009,4.077c3.047,2.72,4.57,6.246,4.57,10.591c0,0.899-0.1,2.483-0.315,4.747 c-0.21,2.269-0.601,4.348-1.171,6.239l-5.82,20.605c-0.477,1.655-0.906,3.547-1.279,5.676c-0.385,2.115-0.569,3.731-0.569,4.815 c0,2.736,0.61,4.604,1.833,5.597c1.232,0.993,3.354,1.487,6.368,1.487c1.415,0,3.025-0.251,4.814-0.744 C76.854,100.348,78.155,99.915,78.962,99.536z M80.438,13.03c0,3.59-1.353,6.656-4.072,9.177c-2.712,2.53-5.98,3.796-9.803,3.796 c-3.835,0-7.111-1.266-9.854-3.796c-2.738-2.522-4.11-5.587-4.11-9.177c0-3.583,1.372-6.654,4.11-9.207 C59.447,1.274,62.729,0,66.563,0c3.822,0,7.091,1.277,9.803,3.823C79.087,6.376,80.438,9.448,80.438,13.03 Z"></path>
                    </g>
                </g>
            </Svg>
        );
    }
}

// Info Download
export class IconDownload extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '12px'}
                height={this.props.height || '11px'}
                viewBox="0 0 12 11"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-525.000000, -384.000000)"
                        fill={this.props.color || Theme.darkText}
                    >
                        <g transform="translate(512.000000, 376.000000)">
                            <path d="M24.25,13 C23.8355,13 23.5,13.336 23.5,13.75 L23.5,17.5 L14.5,17.5 L14.5,13.75 C14.5,13.336 14.1645,13 13.75,13 C13.3355,13 13,13.336 13,13.75 L13,18.25 C13,18.664 13.3355,19 13.75,19 L24.25,19 C24.6645,19 25,18.664 25,18.25 L25,13.75 C25,13.336 24.6645,13 24.25,13 L24.25,13 Z M22,11.2666667 L20,11.2666667 L20,8.46666667 C20,8.21 19.775,8 19.5,8 L18.5,8 C18.225,8 18,8.21 18,8.46666667 L18,11.2666667 L16,11.2666667 L19,15 L22,11.2666667 Z"></path>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

// Toggle Icon (i.e. Route advisor)
export class IconToggle extends IconBase {
    render() {
        return (
            <Svg
                margin={this.props.margin}
                width={this.props.width || '17px'}
                height={this.props.height || '16px'}
                cssTransform={this.props.cssTransform}
                viewBox="0 0 19 18"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-11.000000, -7.000000)"
                        fill={this.props.color || Theme.darkText}
                    >
                        <path d="M23.0909091,20.9090909 C23.0909091,20.1563636 22.5105455,19.5454545 21.7954545,19.5454545 C21.0803636,19.5454545 20.5,20.1563636 20.5,20.9090909 L20.5,21.3636364 L11,21.3636364 L11,23.1818182 L20.5,23.1818182 L20.5,23.6363636 C20.5,24.39 21.0803636,25 21.7954545,25 C22.5105455,25 23.0909091,24.39 23.0909091,23.6363636 L23.0909091,23.1818182 L30,23.1818182 L30,21.3636364 L23.0909091,21.3636364 L23.0909091,20.9090909 Z M16.1818182,14.6363636 C16.1818182,13.8836364 15.6014545,13.2727273 14.8863636,13.2727273 C14.1712727,13.2727273 13.5909091,13.8836364 13.5909091,14.6363636 L13.5909091,15.0909091 L11,15.0909091 L11,16.9090909 L13.5909091,16.9090909 L13.5909091,17.3636364 C13.5909091,18.1172727 14.1712727,18.7272727 14.8863636,18.7272727 C15.6014545,18.7272727 16.1818182,18.1172727 16.1818182,17.3636364 L16.1818182,16.9090909 L30,16.9090909 L30,15.0909091 L16.1818182,15.0909091 L16.1818182,14.6363636 Z M26.5454545,8.81818182 L26.5454545,8.36363636 C26.5454545,7.61090909 25.9650909,7 25.25,7 C24.5349091,7 23.9545455,7.61090909 23.9545455,8.36363636 L23.9545455,8.81818182 L11,8.81818182 L11,10.6363636 L23.9545455,10.6363636 L23.9545455,11.0909091 C23.9545455,11.8445455 24.5349091,12.4545455 25.25,12.4545455 C25.9650909,12.4545455 26.5454545,11.8445455 26.5454545,11.0909091 L26.5454545,10.6363636 L30,10.6363636 L30,8.81818182 L26.5454545,8.81818182 Z"></path>
                    </g>
                </g>
            </Svg>
        );
    }
}

// Arrow sort icon
// Use in tables to indicate that this is what is being sorted
export class IconSort extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '9px'}
                height={this.props.height || '9px'}
                viewBox="0 0 9 9"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(0.000000, -1.000000)"
                        stroke={this.props.color || Theme.defaultGray}
                    >
                        <g transform="translate(1.000000, 1.000000)">
                            <path d="M3.5,0.5 L3.5,7.5 L3.5,0.5 Z"></path>
                            <polyline
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                points="0.299987793 5 3.48854245 8.67292965 6.87464608 5"
                            ></polyline>
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

// Circle X close icon
// Use for modal headers and similar
export class IconCircleClose extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                width={this.props.width || '16px'}
                height={this.props.height || '16px'}
                viewBox="0 0 38 38"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-1.000000, -1.000000)"
                        fillRule="nonzero"
                        fill={this.props.color || '#fff'}
                    >
                        <g transform="translate(1.000000, 1.000000)">
                            <path d="M28.456621,24.6392694 C28.456621,24.2054795 28.283105,23.7716895 27.9360731,23.5114155 L23.5114155,19 L27.9360731,14.4885845 C28.283105,14.2283105 28.456621,13.7945205 28.456621,13.3607306 C28.456621,12.9269406 28.283105,12.5799087 27.9360731,12.2328767 L25.7671233,10.0639269 C25.4200913,9.71689498 25.0730594,9.543379 24.6392694,9.543379 C24.2054795,9.543379 23.7716895,9.71689498 23.5114155,10.0639269 L19,14.4885845 L14.4885845,10.0639269 C14.2283105,9.71689498 13.7945205,9.543379 13.3607306,9.543379 C12.9269406,9.543379 12.5799087,9.71689498 12.2328767,10.0639269 L10.0639269,12.2328767 C9.71689498,12.5799087 9.543379,12.9269406 9.543379,13.3607306 C9.543379,13.7945205 9.71689498,14.2283105 10.0639269,14.4885845 L14.4885845,19 L10.0639269,23.5114155 C9.71689498,23.7716895 9.543379,24.2054795 9.543379,24.6392694 C9.543379,25.0730594 9.71689498,25.4200913 10.0639269,25.7671233 L12.2328767,27.9360731 C12.5799087,28.283105 12.9269406,28.456621 13.3607306,28.456621 C13.7945205,28.456621 14.2283105,28.283105 14.4885845,27.9360731 L19,23.5114155 L23.5114155,27.9360731 C23.7716895,28.283105 24.2054795,28.456621 24.6392694,28.456621 C25.0730594,28.456621 25.4200913,28.283105 25.7671233,27.9360731 L27.9360731,25.7671233 C28.283105,25.4200913 28.456621,25.0730594 28.456621,24.6392694 Z M38,19 C38,22.4703196 37.2191781,25.6803653 35.4840183,28.543379 C33.7488584,31.4931507 31.4931507,33.7488584 28.543379,35.4840183 C25.6803653,37.2191781 22.4703196,38 19,38 C15.5296804,38 12.3196347,37.2191781 9.456621,35.4840183 C6.50684932,33.7488584 4.25114155,31.4931507 2.51598174,28.543379 C0.780821918,25.6803653 0,22.4703196 0,19 C0,15.5296804 0.780821918,12.3196347 2.51598174,9.456621 C4.25114155,6.50684932 6.50684932,4.25114155 9.456621,2.51598174 C12.3196347,0.780821918 15.5296804,0 19,0 C22.4703196,0 25.6803653,0.780821918 28.543379,2.51598174 C31.4931507,4.25114155 33.7488584,6.50684932 35.4840183,9.456621 C37.2191781,12.3196347 38,15.5296804 38,19 Z" />
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

export class IconFolder extends IconBase {
    render() {
        return (
            <Svg
                width={this.props.size || '16px'}
                height={this.props.size || '14px'}
                viewBox="0 0 16 14"
                version="1.1"
                xmlns="https://www.w3.org/2000/svg"
            >
                <title>FEF2E634-4104-4830-ACBC-5AA1109E4A3D@1x</title>
                <g
                    id="Web-Bin1"
                    stroke="none"
                    strokeWidth="1"
                    fill={this.props.color || '#697D90'}
                    fillRule="evenodd"
                >
                    <g
                        id="With-Binders"
                        transform="translate(-176.000000, -137.000000)"
                        fill={this.props.color || '#697D90'}
                    >
                        <g
                            id="Group-4"
                            transform="translate(165.000000, 51.000000)"
                        >
                            <path
                                d="M19.1820582,87.5227071 L18.6340749,86.4230954 C18.5182537,86.1903929 18.2072482,86 17.9433714,86 L13.4546983,86 C13.1905993,86 12.8787045,86.1901748 12.7617718,86.422223 L12.206897,87.5229252 L11.4804024,87.5229252 C11.2163033,87.5229252 11,87.7351272 11,87.9942186 L11,99.3468885 C11,99.6059799 11.2163033,99.8181818 11.4804024,99.8181818 L26.5198199,99.8181818 C26.783919,99.8181818 27,99.6059799 27,99.3468885 L27,87.9942186 C27,87.7349091 26.7836967,87.5227071 26.5198199,87.5227071 L19.1820582,87.5227071 Z"
                                id="Shape"
                            />
                        </g>
                    </g>
                </g>
            </Svg>
        );
    }
}

export class IconPeople extends IconBase {
    render() {
        return (
            <Svg
                cssTransform={this.props.cssTransform}
                direction={this.props.direction}
                margin={this.props.margin}
                height={this.props.height || '41px'}
                width={this.props.width || '30px'}
                viewBox="1 0 40 1"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g
                        transform="translate(0, -15)"
                        fill={this.props.color || '#fff'}
                        fillRule="evenodd"
                    >
                        <path d="M28 8.0001C28.5523 8.0001 29 8.44781 29 9.0001V20.6608C29 21.2131 28.5523 21.6608 28 21.6608L16.227 21.66V8L28 8.0001ZM15 18.0001V21.66L13 21.6608C12.4477 21.6608 12 21.2131 12 20.6608V18.0001H15ZM19.8688 12.632C19.8688 11.202 21.0162 9.99198 22.4505 9.99198C23.8489 9.99198 25.0322 11.202 25.0322 12.632C25.0322 13.6586 24.4585 14.5387 23.5979 14.942C25.5342 15.5653 26.9326 17.582 26.9326 19.892H17.9326C17.9326 17.5086 19.3668 15.5653 21.2672 14.942C20.4425 14.5387 19.8688 13.6586 19.8688 12.632ZM15 13.0001V17.0001H12V13.0001H15ZM15 12.0001V8L13 8.0001C12.4477 8.0001 12 8.44781 12 9.0001V12.0001H15Z" />
                    </g>
                </g>
            </Svg>
        );
    }
}

export class IconDrive extends IconBase {
    render() {
        return (
            <svg
                width="17px"
                height="16px"
                viewBox="0 0 17 16"
                version="1.1"
                xmlns="https://www.w3.org/2000/svg"
            >
                <title>75D436B3-9CDE-4331-9B8D-81DBBED53A9B@1x</title>
                <g
                    id="Web-Bin1"
                    stroke="none"
                    strokeWidth="1"
                    fill={this.props.color || '#697D90'}
                    fillRule="evenodd"
                >
                    <g
                        id="With-Binders"
                        transform="translate(-176.000000, -239.000000)"
                        fill={this.props.color || '#697D90'}
                    >
                        <g
                            id="Group-4"
                            transform="translate(165.000000, 51.000000)"
                        >
                            <path
                                d="M26.3428828,199.061452 L11.6739939,199.061452 C11.3064384,199.061452 11.0084384,199.355443 11.0084384,199.717836 L11.0084384,202.874134 C11.0084384,203.236526 11.3064384,203.530737 11.6739939,203.530737 L26.3428828,203.530737 C26.7104384,203.530737 27.0084384,203.236526 27.0084384,202.874134 L27.0084384,199.717836 C27.0084384,199.355443 26.7106606,199.061452 26.3428828,199.061452 L26.3428828,199.061452 Z M24.6899939,200.454678 C25.2148828,200.454678 25.6404384,200.87429 25.6404384,201.391899 C25.6404384,201.909947 25.2148828,202.329559 24.6899939,202.329559 C24.1653272,202.329559 23.7399939,201.909947 23.7399939,201.391899 C23.7399939,200.87429 24.1653272,200.454678 24.6899939,200.454678 Z M24.757105,188.985282 C25.2857717,188.985282 25.7146606,189.408183 25.7146606,189.929957 L25.7146606,189.929957 L26.813105,198.029741 C26.663105,197.988745 26.5057717,197.965287 26.3428828,197.965287 L26.3428828,197.965287 L11.6739939,197.965287 C11.509105,197.965287 11.3504384,197.989402 11.1986606,198.030837 L11.1986606,198.030837 L12.2973272,189.929957 C12.2973272,189.408183 12.7262161,188.985282 13.2548828,188.985282 L13.2548828,188.985282 Z"
                                id="Shape"
                            />
                        </g>
                    </g>
                </g>
            </svg>
        );
    }
}

export class IconCog extends IconBase {
    render() {
        return (
            <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    opacity="0.4"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.03471 9.98544C5.40401 9.98544 4.08333 8.66513 4.08333 7.03471C4.08333 5.40493 5.40401 4.08333 7.03471 4.08333C8.66413 4.08333 9.98544 5.40493 9.98544 7.03471C9.98544 8.66513 8.66413 9.98544 7.03471 9.98544ZM13.4622 5.92258H12.8164C12.5201 5.92258 12.2057 5.69158 12.1182 5.40808L11.7466 4.50625C11.6077 4.24608 11.6643 3.8605 11.8732 3.65167L12.3322 3.19317C12.5417 2.98317 12.5417 2.64075 12.3322 2.43133L11.5687 1.6695C11.3604 1.46008 11.0174 1.46008 10.808 1.6695L10.3483 2.128C10.1401 2.33742 9.75392 2.394 9.49317 2.254L8.59308 1.883C8.31017 1.79608 8.07858 1.48167 8.07858 1.18475V0.539C8.07858 0.242667 7.83592 0 7.539 0H6.46217C6.16583 0 5.92317 0.242667 5.92317 0.539V1.18475C5.92317 1.48167 5.69217 1.79608 5.40983 1.883L4.50858 2.254C4.24608 2.39458 3.86225 2.338 3.65283 2.128L3.19375 1.6695C2.98375 1.46008 2.64192 1.46008 2.4325 1.6695L1.67125 2.43133C1.46067 2.64017 1.46067 2.98317 1.67125 3.19258L2.12858 3.65167C2.338 3.8605 2.39633 4.24608 2.25458 4.50625L1.88475 5.40867C1.7955 5.69217 1.48225 5.92317 1.18592 5.92317L0.539 5.92258C0.242667 5.92258 0 6.16467 0 6.46158V7.53842C0 7.83417 0.242667 8.07625 0.539 8.07625H1.18592C1.48225 8.07683 1.7955 8.30958 1.88358 8.59192L2.25458 9.49375C2.39575 9.7545 2.338 10.1407 2.12858 10.3495L1.67008 10.8074C1.46067 11.0168 1.46067 11.3587 1.67008 11.5698L2.4325 12.3311C2.64192 12.5411 2.98375 12.5411 3.19375 12.3311L3.65283 11.8732C3.86167 11.6643 4.24608 11.6072 4.50625 11.7478L5.40983 12.1193C5.69217 12.2068 5.92317 12.5213 5.92317 12.817V13.4622C5.92317 13.7579 6.16583 14 6.46217 14H7.539C7.83592 14 8.07858 13.7579 8.07858 13.4622V12.817C8.07858 12.5213 8.31017 12.2068 8.59308 12.1193L9.4955 11.7478C9.75625 11.6072 10.1412 11.6643 10.3512 11.8732L10.808 12.3311C11.0174 12.5411 11.3604 12.5411 11.5687 12.3311L12.3322 11.5698C12.5417 11.3587 12.5417 11.0168 12.3322 10.8074L11.8732 10.3495C11.6643 10.1407 11.6077 9.7545 11.7466 9.49375L12.1182 8.59192C12.2057 8.30958 12.5218 8.07683 12.8164 8.07683H13.4622C13.7585 8.07683 14 7.83533 14 7.539V6.46158C14 6.16467 13.7585 5.92258 13.4622 5.92258Z"
                    fill={this.props.color || '#6D767D'}
                />
            </svg>
        );
    }
}

export class IconFile extends IconBase {
    render() {
        return (
            <svg
                width="20px"
                height="21px"
                viewBox="0 0 20 21"
                version="1.1"
                xmlns="https://www.w3.org/2000/svg"
            >
                <title>file icon</title>
                <g
                    id="Web-Bin1"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <g
                        id="Search-Copy-2"
                        transform="translate(-456.000000, -853.000000)"
                        fill="#677E91"
                        fillRule="nonzero"
                    >
                        <path
                            d="M476,853 L476,873.327869 L456,873.327869 L456,853 L476,853 Z M475,853.999 L457,853.999 L457,872.327 L475,872.327 L475,853.999 Z M471.755269,867.090164 L471.755269,868.090164 L460.244731,868.090164 L460.244731,867.090164 L471.755269,867.090164 Z M471.755269,862.5 L471.755269,863.5 L460.244731,863.5 L460.244731,862.5 L471.755269,862.5 Z M471.755269,857.909836 L471.755269,858.909836 L460.244731,858.909836 L460.244731,857.909836 L471.755269,857.909836 Z"
                            id="file-icon"
                        />
                    </g>
                </g>
            </svg>
        );
    }
}

export class IconNewFolder extends IconBase {
    render() {
        return (
            <svg
                data-cy="add-to-binder"
                width="21px"
                height="19px"
                viewBox="0 0 21 19"
                version="1.1"
                xmlns="https://www.w3.org/2000/svg"
            >
                <g
                    id="Web-Bin1"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <g
                        id="Document-View-Copy"
                        transform="translate(-1396.000000, -16.000000)"
                        fill="#FFFFFF"
                    >
                        <g
                            id="Top-Nav-Bar-/-85h"
                            transform="translate(165.000000, 0.000000)"
                        >
                            <path
                                d="M1246.75,30.765625 L1247.73438,30.765625 L1247.73438,29.78125 C1247.73438,29.2375469 1248.17538,28.796875 1248.71875,28.796875 C1249.26245,28.796875 1249.70312,29.2375469 1249.70312,29.78125 L1249.70312,30.765625 L1250.6875,30.765625 C1251.2312,30.765625 1251.67188,31.2062969 1251.67188,31.75 C1251.67188,32.2937031 1251.2312,32.734375 1250.6875,32.734375 L1249.70312,32.734375 L1249.70312,33.71875 C1249.70312,34.2624531 1249.26245,34.703125 1248.71875,34.703125 C1248.17538,34.703125 1247.73438,34.2624531 1247.73438,33.71875 L1247.73438,32.734375 L1246.75,32.734375 C1246.20663,32.734375 1245.76562,32.2937031 1245.76562,31.75 C1245.76562,31.2062969 1246.20663,30.765625 1246.75,30.765625 L1246.75,30.765625 Z M1231,18.953125 L1231,16.984375 C1231,16.4406719 1231.441,16 1231.98438,16 L1236.90625,16 L1238.86942,17.96875 L1251.01562,17.96875 C1251.55933,17.96875 1252,18.4094219 1252,18.953125 L1252,19.9375 L1231,19.9375 L1231,18.953125 L1231,18.953125 Z M1250.6875,29.78125 C1250.6875,28.6938437 1249.80616,27.8125 1248.71875,27.8125 C1247.63167,27.8125 1246.75,28.6938437 1246.75,29.78125 C1245.66292,29.78125 1244.78125,30.6625937 1244.78125,31.75 C1244.78125,31.9813281 1244.8285,32.2001875 1244.902,32.40625 L1231.98438,32.40625 C1231.441,32.40625 1231,31.9655781 1231,31.421875 L1231,20.921875 L1252,20.921875 L1252,30.2921406 C1251.6512,29.9777969 1251.19412,29.78125 1250.6875,29.78125 L1250.6875,29.78125 Z"
                                id="Fill-204"
                            />
                        </g>
                    </g>
                </g>
            </svg>
        );
    }
}

export class IconKebab extends IconBase {
    render() {
        return (
            <svg
                width="18px"
                height="4px"
                viewBox="0 0 18 4"
                version="1.1"
                xmlns="https://www.w3.org/2000/svg"
            >
                <title>Menu</title>
                <g
                    id="V7"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <g
                        id="Documents---Filter-By-turned-on-Option-1"
                        transform="translate(-1364.000000, -502.000000)"
                        fill="#222222"
                    >
                        <g
                            id="Group-12"
                            transform="translate(449.000000, 200.000000)"
                        >
                            <path
                                d="M917,302 C918.104569,302 919,302.895431 919,304 C919,305.104569 918.104569,306 917,306 C915.895431,306 915,305.104569 915,304 C915,302.895431 915.895431,302 917,302 Z M924,302 C925.104569,302 926,302.895431 926,304 C926,305.104569 925.104569,306 924,306 C922.895431,306 922,305.104569 922,304 C922,302.895431 922.895431,302 924,302 Z M931,302 C932.104569,302 933,302.895431 933,304 C933,305.104569 932.104569,306 931,306 C929.895431,306 929,305.104569 929,304 C929,302.895431 929.895431,302 931,302 Z"
                                id="kabob"
                            />
                        </g>
                    </g>
                </g>
            </svg>
        );
    }
}

export class IconEmptyBinder extends IconBase {
    render() {
        return (
            <svg
                width="100px"
                height="88px"
                viewBox="0 0 100 88"
                version="1.1"
                xmlns="https://www.w3.org/2000/svg"
            >
                <title>670935D6-20D8-42D6-A75B-6D19A3F085A7@1x</title>
                <g
                    id="Web-Bin1"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <g
                        id="Empty-Binder"
                        transform="translate(-869.000000, -383.000000)"
                        fill="#BECAD4"
                    >
                        <path
                            d="M913.208333,394.622642 L905.511667,383.911547 L904.858333,383 L869,383 L869,471 L969,471 L969,394.622642 L913.208333,394.622642 L913.208333,394.622642 Z M965.666667,397.943396 L965.666667,406.245283 L921.56,406.245283 L915.595,397.943396 L965.666667,397.943396 L965.666667,397.943396 Z M872.333333,467.679245 L872.333333,386.320755 L903.141667,386.320755 L911.475,397.943396 L911.495,397.943396 L919.311667,408.820528 C919.636667,409.272151 920.146667,409.512906 920.666667,409.514566 L920.666667,409.566038 L965.666667,409.566038 L965.666667,467.679245 L872.333333,467.679245 L872.333333,467.679245 Z"
                            id="folder"
                        />
                    </g>
                </g>
            </svg>
        );
    }
}

export class IconCloudAhoy extends IconBase {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.6272 7.49033C17.5064 7.03029 17.0292 6.75452 16.5692 6.88097L13.5158 7.69733L9.54815 4L8.43841 4.29338L10.819 8.41622L7.96118 9.18087L6.82842 8.29532L5.99459 8.51951L7.04111 10.3366L7.48381 11.1013L8.40388 10.8542L11.4572 10.0376L13.9585 9.37054L17.0119 8.5539C17.4776 8.42177 17.7479 7.95022 17.6272 7.49019V7.49033ZM20 8.30114V19.7389L8.8201 16.6428L4.49192 12.4471L20 8.30114ZM11.3863 19.7389L4 12.5789V17.107L11.3863 19.7389Z"
                    fill={this.props.color}
                />
            </svg>
        );
    }
}
